module.exports = __webpack_public_path__ + "gce.logo.cc1cc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/logo/gce.logo.svg
// module id = 3618
// module chunks = 0